module.exports = __webpack_public_path__ + "static/media/creature-palm.102ad4dc.svg";